import type { AxiosRequestConfig } from 'axios';
import { AGraphEnvType, CHANNEL_HEADER } from '../../APIConstants';
import { awPortfolioAnalysisReportApiClient } from './Base';
import type {
  GenerateConstraintsRequest,
  GenerateConstraintsResponse,
  GenerateRelevantColumnsRequest,
  GenerateRelevantColumnsResponse,
} from './types';

/*
 * Currently, /analytics/reporting is running using channel. Since we are moving towards stripes
 * we no longer have beta instance supported via channel. Hence, temporarily hardcoding to stable environment
 * until we migrate to stripes completely.
 */
const SMART_FILTER_API_CONFIG = {
  headers: {
    [CHANNEL_HEADER]: AGraphEnvType.STABLE,
  },
};

/**
 * Restricted config type for SmartFilters API calls.
 * Only allows signal for request cancellation to prevent unintended Axios config exposure.
 */
type SmartFiltersRequestConfig = Pick<AxiosRequestConfig, 'signal'>;

export function generateRelevantColumns(body: GenerateRelevantColumnsRequest, config?: SmartFiltersRequestConfig) {
  return awPortfolioAnalysisReportApiClient.post<GenerateRelevantColumnsResponse>(
    'smartFilters:generateRelevantColumns',
    body,
    { ...SMART_FILTER_API_CONFIG, ...config }
  );
}

export function generateConstraints(body: GenerateConstraintsRequest, config?: SmartFiltersRequestConfig) {
  return awPortfolioAnalysisReportApiClient.post<GenerateConstraintsResponse>(
    'smartFilters:generateConstraints',
    body,
    { ...SMART_FILTER_API_CONFIG, ...config }
  );
}
